<template>
  <item-dialog ref="dialog" @refresh="$emit('refresh', $event)" />
</template>

<script>
import ItemDialog from './ItemDialog.vue'

export default {
  name: 'AddWhItem',

  components: {
    ItemDialog
  },

  methods: {
    open () {
      this.$refs.dialog.open()
    },

    close () {
      this.$refs.dialog.close()
    }
  }
}
</script>
